import { matchPath } from "react-router";
import { CLIENTS_ROUTES } from "../../../../consts/routes";

export const getPathParams = () => {
  const { params } = matchPath(window.location.pathname, {
    path: CLIENTS_ROUTES.documentView({
      actionType: ":actionType",
      resourceType: ":resourceType",
      documentId: ":documentId?",
      clientId: ":clientId",
      type: ":type",
    }),
    exact: true,
    strict: false,
  });

  return {
    patientId: params.clientId ? Number(params.clientId) : undefined,
    documentId: params.documentId ? Number(params.documentId) : undefined,
  };
};
